// src/services/cursoService.js
import api from './api';

const cursoService = {
  // Listar cursos com paginação e filtros
  list: async (params = {}) => {
    try {
      const response = await api.get('/cursos', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao listar cursos:', error);
      
      if (error.response?.data) {
        const errorData = error.response.data;
        throw new Error(errorData.message || errorData.error || 'Erro ao buscar cursos');
      }
      
      throw new Error('Erro de conexão. Tente novamente.');
    }
  },

  // Buscar curso por ID
  getById: async (id) => {
    try {
      const response = await api.get(`/cursos/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar curso:', error);
      
      if (error.response?.data) {
        const errorData = error.response.data;
        throw new Error(errorData.message || errorData.error || 'Erro ao buscar curso');
      }
      
      throw new Error('Erro de conexão. Tente novamente.');
    }
  },

  // Criar novo curso
  create: async (cursoData) => {
    try {
      const response = await api.post('/cursos', cursoData);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar curso:', error);
      
      // Se há resposta do servidor, usar os dados dela
      if (error.response?.data) {
        const errorData = error.response.data;
        throw new Error(errorData.message || errorData.error || 'Erro ao criar curso');
      }
      
      // Erro de rede ou outro problema
      throw new Error('Erro de conexão. Tente novamente.');
    }
  },

  // Atualizar curso
  update: async (id, cursoData) => {
    try {
      const response = await api.put(`/cursos/${id}`, cursoData);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar curso:', error);
      
      // Se há resposta do servidor, usar os dados dela
      if (error.response?.data) {
        const errorData = error.response.data;
        throw new Error(errorData.message || errorData.error || 'Erro ao atualizar curso');
      }
      
      // Erro de rede ou outro problema
      throw new Error('Erro de conexão. Tente novamente.');
    }
  },

  // Deletar curso
  delete: async (id) => {
    try {
      const response = await api.delete(`/cursos/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar curso:', error);
      
      if (error.response?.data) {
        const errorData = error.response.data;
        throw new Error(errorData.message || errorData.error || 'Erro ao deletar curso');
      }
      
      throw new Error('Erro de conexão. Tente novamente.');
    }
  },

  // Aliases para compatibilidade com componentes existentes
  listarCursos: function(params = {}) {
    return this.list(params);
  },

  buscarCursos: function(searchTerm = '') {
    return this.list({ search: searchTerm });
  }
};

export default cursoService;
